import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { MusicPlatformAudioProps } from "./types";
import {
  PropertyDefinition,
  PropertyMappingType,
} from "app/library/layout-builder";

export class MusicPlatformAudioDefinitions extends CmsReactComponent<MusicPlatformAudioProps> {

  static schemaName = "music-platform-audio";

  static propertyDefinitions: PropertyDefinition[] = [
    {
      name: "groups",
      mapping: {
        type: PropertyMappingType.ArrayData,
        keys: [
          {
            name: "title",
            mapping: {
              type: PropertyMappingType.String
            },
            text: "Başlık"
          },
          {
            name: "audio",
            mapping: {
              type: PropertyMappingType.File
            },
            text: "Ses"
          },
          {
            name: "video",
            mapping: {
              type: PropertyMappingType.File
            },
            text: "Video"
          },
          {
            name: "content",
            mapping: {
              type: PropertyMappingType.Html
            },
            text: "İçerik"
          },
        ]
      },
      text: "İçerik grupları",
    },
    {
      name: "isDark",
      mapping: {
        type: PropertyMappingType.Boolean
      },
      text: "Koyu Tema"
    },
  ];
}
